import { render } from "./ToPay.vue?vue&type=template&id=4b8950b0&scoped=true"
import script from "./ToPay.vue?vue&type=script&lang=js"
export * from "./ToPay.vue?vue&type=script&lang=js"

import "./ToPay.vue?vue&type=style&index=0&id=4b8950b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b8950b0"]])

export default __exports__